export default "__VITE_ASSET__CKedxq4W__"